import React, { useEffect } from 'react';
import PropTypes from "prop-types";
import { getUniUniTrackingDetails } from '../../store/actions/batch.action';
import Modal from "react-bootstrap/Modal";
import LoaderSpinner from '../common/Loader';
import './tracking.css';
import moment from 'moment';

/* istanbul ignore next */
const UniUniTrackingDetails = (props) => {
    const { trackingNumber, item, ...modalProps } = props;
    const [showLoader, setShowLoader] = React.useState(false);
    const [trackingResponse, setTrackingResponse] = React.useState({});
    const [errorDetails, setErrorDetails] = React.useState({ show: false, message: '' });

    useEffect(() => {
        fetchTrackingDetails();
    }, [trackingNumber]);

    const fetchTrackingDetails = async () => {
        const trackingDetails = {
            trackingNumber: trackingNumber,
        };
        setShowLoader(true);
        const res = await getUniUniTrackingDetails(trackingDetails);
        if (res.data.Status === 200) {
            setTrackingResponse(res.data.Entity);
            setErrorDetails({ show: false, message: '' });
        } else {
            setErrorDetails({ show: true, message: res.data.Message.AppStatusDescription });
        }
        setShowLoader(false);
    };

    const trackingEvents = trackingResponse?.data || trackingResponse?.trackingEvents || [];

    return (
        <Modal {...modalProps} className="modalDeleteWrapper" size="lg">
            <Modal.Header closeButton>
                <div className="modal-main-div">
                    <span className="modal-m-text">Tracking History {showLoader && <LoaderSpinner />}</span>
                </div>
            </Modal.Header>
            <Modal.Body className="fontFix trackingModal">
                <div className='mb-1'>
                    <div className='heading mb-1'>Tracking: {trackingNumber}</div>
                    <div>{item?.ReceiverName}</div>
                    <div>{item?.ReceiverAddressLine1}</div>
                    <div>{item?.ReceiverAddressLine2}</div>
                    <div>{item?.ReceiverAddressLine3}</div>
                    <div>{item?.ReceiverCity} {item?.ReceiverState} {item?.ReceiverZip} {item?.CountryCode}</div>
                </div>
                <div className="trackingBox pt-1">
                    <div className="timeline">
                        {trackingEvents?.map((event, index) => (
                            <div className={`timeline-item ${(event.description_en || event.eventType || '').includes('Delivered') ? 'delivered' : ''}`} key={index}> {/* NOSONAR */}
                                <div className="status">{event.description_en || event.eventType || '-'}</div>
                                <div className="sub-status">{event.data_source || event.subStatus || '-'}</div>
                                <div className="location">{event.pathAddress || `${event.eventCity || ''} ${event.eventState || ''} ${event.eventZIP || ''}`.trim() || '-'}</div>
                                <div className="date">{event.pathTimeLocalized || (event.eventTimestamp && moment(event.eventTimestamp).format('MMMM D, YYYY, h:mm a')) || '-'}</div>
                                <div className="sub-status">Tracking Number: {event.tracking_number || trackingNumber}</div>
                                <div className="sub-status">Time Zone: {event.pathTimeZone || '-'}</div>
                            </div>
                        ))}
                    </div>
                </div>
                {errorDetails.show && (
                    <div className="error-message tracking">{errorDetails.message}</div>
                )}
            </Modal.Body>
        </Modal>
    );
};

UniUniTrackingDetails.propTypes = {
    trackingNumber: PropTypes.string.isRequired,
    item: PropTypes.object.isRequired
};

export default UniUniTrackingDetails;
